import img0 from "./img_0.png";
import img1 from "./img_1.png";

export default {
  v: "5.5.9",
  fr: 29.9700012207031,
  ip: 0,
  op: 180.00000733155,
  w: 636,
  h: 646,
  nm: "Digitail Documents and Data Animation",
  ddd: 0,
  assets: [
    { id: "image_0", w: 372, h: 492, u: "", p: img0, e: 0 },
    { id: "image_1", w: 604, h: 317, u: "", p: img1, e: 0 },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: "Papers",
          refId: "image_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [971, 326.5, 0], ix: 2 },
            a: { a: 0, k: [185.75, 245.75, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                  o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                  t: 30,
                  s: [0, 0, 100]
                },
                {
                  i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                  o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                  t: 90,
                  s: [100, 100, 100]
                },
                {
                  i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                  o: { x: [0.736, 0.736, 0.333], y: [0, 0, 0] },
                  t: 135,
                  s: [100, 100, 100]
                },
                { t: 180.00000733155, s: [0, 0, 100] }
              ],
              ix: 6
            }
          },
          ao: 0,
          ip: 0,
          op: 180.00000733155,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 2,
          nm: "Layer 1",
          refId: "image_1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [960, 540, 0], ix: 2 },
            a: { a: 0, k: [301.921, 158.427, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 180.00000733155,
          st: 0,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "Digital Documents and Data",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [296, 482, 0], ix: 2 },
        a: { a: 0, k: [960, 540, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      w: 1920,
      h: 1080,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
